import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Popup } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';

class TempStatistics extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { data } = this.props;

    return (
      <div className={'inline-conf-area'}>
        <Popup trigger={<div>{data.value}</div>} position="right center">
          <div className={'font-size-13'}>{data.detail}</div>
        </Popup>
      </div>
    );
  }
}

export default injectIntl(TempStatistics);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/TempStatistics.js